import { render, staticRenderFns } from "./parcel.vue?vue&type=template&id=869e9034&scoped=true"
import script from "./parcel.vue?vue&type=script&lang=js"
export * from "./parcel.vue?vue&type=script&lang=js"
import style0 from "./parcel.vue?vue&type=style&index=0&id=869e9034&prod&lang=css"
import style1 from "./parcel.vue?vue&type=style&index=1&id=869e9034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869e9034",
  null
  
)

export default component.exports